import ConfirmSettings from "@app/analytics/TutorialsAndPopups/ConfirmSettings/ConfirmSettings";
import useAuth from "@app/common/auth/useAuth";
import Config from "@app/config";

import FirmographicsPopup from "./FirmographicsPopup";
import FirstTimeTutorial from "./FirstTimeTutorial";
import ProductivityFeaturePopup from "./ProductivityFeaturePopup";

const Tutorials = () => {
  const { impersonating } = useAuth();

  // don't show tutorials or popups while impersonating
  if (impersonating) return null;

  return (
    <>
      <FirstTimeTutorial priority={1} />
      {Config.flags.enableEuSettingsPopup && <ConfirmSettings priority={2} />}
      <FirmographicsPopup priority={3} />
      <ProductivityFeaturePopup priority={4} />
    </>
  );
};

export default Tutorials;
